import React from "react";
import { orderUtils } from "../Helpers/OderUtils";

const LineItem = ({ item, order, egiftcard }) => {
    let itemPictureUrl = orderUtils.getItemPicture(item);
    const productName = orderUtils.getFilteredLineItemName(item, order);
    const variantName = orderUtils.getFilteredLineItemVariant(item);

    return (
        <div className="line-item-container">
            <div className="line-items-column-1">
                <img className="order-item-image" src={itemPictureUrl} alt={item.title} onError={e => (e.target.src = orderUtils.getFallbackImageUrl())} />
                <div className="layout vertical">
                    <span className="line-item-title">{productName}</span>
                    {!egiftcard && variantName && <span className="line-item-variant-name">{variantName}</span>}
                    <span className="line-item-price-mobile">{item.price_formatted || item.price}</span>
                </div>
            </div>
            <div className="line-items-column-2">
                <span className="line-item-quantity">{item.quantity}</span>
            </div>
            <div className="line-items-column-3">
                <span className="line-item-price">{item.price_formatted || item.price}</span>
            </div>
        </div>
    );
};

export default LineItem;



// WEBPACK FOOTER //
// ./src/views/Order/components/_LineItem.jsx